import React from "react";

import EmptyModels from "@/assets/images/EmptyModels.svg?react";
import EmptyTeams from "@/assets/images/EmptyTeams.svg?react";
import EmptyTrash from "@/assets/images/EmptyTrash.svg?react";
import EmptyTokens from "@/assets/images/EmptyTokens.svg?react";
import EmptyConnections from "@/assets/images/EmptyConnections.svg?react";

const illustrations = {
  models: EmptyModels,
  teams: EmptyTeams,
  trash: EmptyTrash,
  tokens: EmptyTokens,
  connections: EmptyConnections,
} as const;

export type EmptyStateVariant = keyof typeof illustrations;

interface EmptyStateProps {
  variant?: EmptyStateVariant;
  title: string;
  subtitle?: string;
  secondary?: boolean;
  /// Optional call-to-action rendered under the subtitle (e.g. a primary
  /// "New model" button).
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  variant,
  title,
  subtitle,
  secondary = false,
  action,
}) => {
  const Illustration = variant ? illustrations[variant] : null;

  return (
    <div className="flex flex-col items-center pt-[10%] h-full select-none gap-1">
      {Illustration && <Illustration className="w-96 h-52 mb-4" />}
      <p
        className={`text-center ${secondary ? "text-fg-muted-regular" : "text-fg-medium"}`}
      >
        {title}
      </p>
      {subtitle && (
        <p className="text-fg-muted-regular text-center">{subtitle}</p>
      )}
      {action && <div className="mt-4 select-auto">{action}</div>}
    </div>
  );
};
